const profileComponent = document.querySelector('.profile');
if (profileComponent) {
  const profileSidebar = profileComponent.querySelector('.profile-sidebar');
  const profileSidebarBtn = profileComponent.querySelector(
    '.profile-sidebar__btn'
  );
  const profileOpenMobBtn = profileComponent.querySelector('.profile-mob-open.fixed-btn');
  const profileOpenMob = profileComponent.querySelector('.profile-mob-open');
  const profileContainer = profileComponent.querySelector('.profile-container');
  const profileSideBarLinks = profileComponent.querySelectorAll('.profile-sidebar__link');

  function openSidebarFunc() {
    const isOpen = profileComponent.classList.contains('is-open-sidebar');

    if (!isOpen) {
      profileComponent.classList.add('is-open-sidebar');
      localStorage.setItem('profileSidebarState', 'open');
    } else {
      profileComponent.classList.remove('is-open-sidebar');
      localStorage.setItem('profileSidebarState', 'closed');
    }
  }

  function closeSideBarFunc() {
    if (profileComponent.classList.contains('is-open-sidebar')) {
      profileComponent.classList.remove('is-open-sidebar');
      localStorage.setItem('profileSidebarState', 'closed');
    }
  }

  profileSidebarBtn.addEventListener('click', () => {
    openSidebarFunc();
  });

  profileOpenMobBtn.addEventListener('click', () => {
    openSidebarFunc();
  });

  profileOpenMob.addEventListener('click', () => {
    openSidebarFunc();
  });

  profileContainer.addEventListener('click', () => {
    if (
      window.innerWidth <= 851 &&
      profileComponent.classList.contains('is-open-sidebar')
    ) {
      profileComponent.classList.remove('is-open-sidebar');
      localStorage.setItem('profileSidebarState', 'closed');
    }
  });


  if (window.innerWidth < 850) {
    profileSideBarLinks.forEach((link) => {
      link.addEventListener('click', () => {
        closeSideBarFunc();
      });
    });
  }
}
